import {Component} from "@angular/core";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";
import {GoBaseComponent} from "../go-base.component";
import {UI_TEXTS} from "../../../enums/e-texts";
import {JP} from "../../../helpers/jp";


@Component({
    selector: "go-storage",
    templateUrl: "./go-storage.component.html"
})


export class GoStorageComponent extends GoBaseComponent {
    UI_TEXTS = UI_TEXTS;


    constructor() {
        super(GO_COMPONENTS.STORAGE);
    }

    onDocumentSet() {
      if (this.component == null || this.document == null) {
        return;
      }
      if (JP.get(this.component, "/categories").length == 0) {
        JP.set(this.document, "/admin/storeByIds", true);
      }
      else {
        JP.set(this.document, "/admin/storeByIds", false);
      }
    }

    onStoreByIdsUpdate(val:boolean)
    {
      if (val)
      {
        JP.set(this.component, "/categories", []);
      }
      else
      {
        JP.set(this.component, "/metaIds", []);
      }
    }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-storage/go-storage.component.ts